import React from "react"
import Helpers, { positionLeft, isActiveSlide } from "../../../../config/Helpers";
import ByDate from "./Reserves/ByDate";
import Preview from "./Reserves/Preview";
import Totals from "./Reserves/Totals";
import Segment from "./Reserves/Segment";
import Channel from "./Reserves/Channel";

class Reserves extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            active_slide : { key : "summary", index : 0 }, 
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
        this.setSegments = this.setSegments.bind(this);
        this.getChannels = this.getChannels.bind(this);
        this.activeMonth = this.activeMonth.bind(this);
        this.activeSegment = this.activeSegment.bind(this);
        this.activeWidget = this.activeWidget.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.callMainRequest = this.callMainRequest.bind(this);
    }
    setDefaultValues(){
        let self = this;
        self.setState(self.getDefaultValues(), function(){
            self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
            self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
        });
    }
    callMainRequest(params = {}){
        let self = this;
        self.props.app.setState(function(prev){
            return {
                sidebar_review : {
                    show : "hide",
                    status: "",
                    current_period : prev.sidebar_review.current_period,
                }
            }
        }, function(){
            self.props.app.mainRequest(params, false)
        })
    }
    getDefaultValues(){
        return {
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                }
            },
            min_slide : 1,
            max_slide : 2, 
            statics: [],
            statics_segments: [],
            statics_channels: [],
            statics_trimester: [],
            statics_aux: [],
            statics_segments_aux: [],
            statics_channels_aux: [],
            total_widgets: [],
            total_widgets_channels: [],
            filters_segment: [],
            filters_channels: [],
            filters_channels_aux: [],
            hidden_wdg_time: "show-widget complete",
            hidden_wdg_room_nights: "show-widget complete",
            hidden_wdg_adr: "show-widget complete",
            hidden_wdg_revenue: "show-widget complete",
            hidden_wdg_revpar: "show-widget complete",
            hide_widget_trimester: "hide-widget",
            key_filter_channel: null,
            filter_ms_active: "inactive",
            filter_month_active: "inactive",
            filter_trimester_active: "inactive",
            filter_segment_active: "inactive",
            request_status: "",
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
    }
    setSegments(segments, key_time, filt) {
        let self = this;
        
        const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
        if (segments !== null) {
            self.setState({
                filters_segment: segments,
                filter_month_active: status,
                key_time: filt,
                filter_ms_active : "active"
            }, function () {
                self.props.app.mainRequest();
            })
        } else {

            //self._widgetSegment.state.segmentActive = {};
            self.setState({
                filters_segment: [],
                filter_month_active: status,
                filter_segment_active: "inactive",
                statics_channels: {},
                segmentActive : {},
                filter_ms_active : "inactive"
            }, function(){
                self._widgetSegment.setState({
                    segmentActive : {}
                }, function(){
                    self.props.app.mainRequest();
                })
            })
        }
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    getChannels(status, segmentActive) {
        let self = this;
        if (status === 'active') {
            self.setState({
                statics_channels: Object.assign({}, self.state.filters_channels),
                filter_segment_active : "active",
                segmentActive : segmentActive
            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
                
            })
        } else {
            self.setState({
                statics_channels : {},
                filter_segment_active : "inactive",
                segmentActive : {}

            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
            })
        }
    }

    activeMonth(status, filt) {
    }
    activeSegment(status) {
        if (status === "inactive") {
            this.setState({
                filters_channels: [],
                statics_channels: []
            });
        }
        this.setState({
            filter_segment_active: status
        })
    }
    activeWidget(type) {
        let status;
        let self = this;
        this.setState(function (prevState) {

            if (type === "time") {
                status = { hidden_wdg_time: prevState.hidden_wdg_time === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "room-nights") {
                status = { hidden_wdg_room_nights: prevState.hidden_wdg_room_nights === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "adr") {
                status = { hidden_wdg_adr: prevState.hidden_wdg_adr === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "revenue") {
                status = { hidden_wdg_revenue: prevState.hidden_wdg_revenue === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }else if (type === "revpar") {
                status = { hidden_wdg_revpar: prevState.hidden_wdg_revpar === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }
            return status;
        })
        setTimeout(() => {
            if (type === "time") {
                self.setState({
                    hidden_wdg_time: self.state.hidden_wdg_time === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "room-nights") {
                self.setState({
                    hidden_wdg_room_nights: self.state.hidden_wdg_room_nights === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "adr") {
                self.setState({
                    hidden_wdg_adr: self.state.hidden_wdg_adr === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "revenue") {
                self.setState({
                    hidden_wdg_revenue: self.state.hidden_wdg_revenue === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }else if (type === "revpar") {
                self.setState({
                    hidden_wdg_revpar: self.state.hidden_wdg_revpar === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }
        }, 200);
    }
    componentWillReceiveProps(props){
        let response = props.app.state.reservation_response_request
        let self = this;
        if(Object.keys(response).length > 0){
            self.setState(function (prevState) {                
                let results = {}
                if (self.state.filters_segment.length > 0) {
                    let filters_channels_aux = {};
                    Object.keys(response.month_widgets).map(function(key) {
                        let rr = response.month_widgets[key];
                        filters_channels_aux[key] = {}
                        Object.keys(rr).map(function(key_two) {
                            filters_channels_aux[key][key_two] = {};
                            if(key_two !== "totals"){
                                /*let rr2 = rr[key_two]["channels"]
                                Object.keys(rr2).map(function(key_three){
                                    filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                });*/
                            }else{
                                filters_channels_aux[key][key_two] = rr[key_two]
                            }
                        });
                    })

                    results = {
                        filters_channels: filters_channels_aux,
                        statics_segments_aux: response.month_widgets,
                        statics_segments: response.month_widgets
                    }
                } else {
                    results = {
                        statics_channels: [],
                        statics_segments: [],
                        statics_trimester: [],
                        statics_aux: response.month_widgets,
                        statics: response.month_widgets,
                        total_widgets: response.total_widgets
                    }
                }
                return results;
            }, function () {
                if(self.state.statics['months'] !== undefined){
                    let filt;
                    filt = self._widgetByDate.state.current_key_time;
                    
                    let state_statics = Object.assign({}, self.state.statics);
                    Object.keys(state_statics['months']).map(function(key){
                        if(filt[key] !== undefined){
                            state_statics['months'][key].state = "active";
                        }else{
                            state_statics['months'][key].state = "inactive";
                        }
                    })
                    self.setState({
                        statics_aux : state_statics,
                        statics : state_statics,
                    },function(){
                        if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegment.state.segmentActive)
                        }
                    })
                }
            })
        }
    }
    activeSlide(slide){
        this._widgetSegment.state.segmentActive = {}
        this.setState({
            active_slide : slide,
            current_slide : slide.key,
            segmentActive : {}
        }, function(){
            if(this.state.active_slide.key === "pickup"){
                this.props.app.state.pickup = 1;
                this.setDefaultValuesModule(true);
            }
        })
    }
    activeChartType(item){
        this.setState({
            active_chart_type : item
        }, function(){

        })
    }
    chartTypes(){
        let self = this;
        const types = [
            { key : "Month", value : "by_month" },
            { key : "Week", value : "by_week" },
            { key : "Day", value : "by_day" }
        ];
        
        let chart_types = types.map((item, index) => (
            <div className={"chart-type-select " + (item.value === self.state.active_chart_type.value ? "active" : "") } key={"list-chart-type-"+index} onClick={self.activeChartType.bind(self, item)}>
                <span children={item.key} />
            </div>
        ))
        return chart_types;
    }

    render() {

        return ( 
            <div style={positionLeft(0, this.state.active_slide.index)} className={"table-split slide " + isActiveSlide(this.state.active_slide.key, "summary", "main-slide")}>
                <ByDate
                    statics={this.state.statics}
                    total_widgets={this.state.total_widgets}
                    activeMonth={this.activeMonth}
                    activeSegment={this.activeSegment}
                    setSegments={this.setSegments}
                    filters_segment={this.state.filters_segment}
                    widgetSegment={this._widgetSegment}
                    getInitialStatics={this.props.app.getInitialStatics}
                    hidden_wdg_time={this.state.hidden_wdg_time}
                    activeWidget={this.activeWidget}
                    current_year={this.props.app.state.current_year}
                    past_year={this.props.app.state.past_year}
                    view_results={this.props.app.state.view_results}
                    request_status={this.state.request_status}
                    layout={this}
                    ref={(child) => { this._widgetByDate = child; }}
                />
                <div className={"container-aux " + this.state.filter_ms_active}>
                    <Segment
                        statics={this.state.statics}
                        filters_segment={this.state.filters_segment}
                        filter_month_active={this.state.filter_month_active}
                        getChannels={this.getChannels}
                        request_status={this.state.request_status}
                        activeSegment={this.activeSegment}
                        layout={this}
                        app={this.props.app}
                        ref={(child) => { this._widgetSegment = child; }}
                    />
                    <Channel
                        filter_segment_active={this.state.filter_segment_active}
                        statics={this.state.statics}
                        filters_channels={this.state.filters_channels}
                        current_filter_channel={this.props.app.state.current_filter_channel}
                        key_filter_channel={this.state.key_filter_channel}
                        skipFilterChannel={this.props.app.skipFilterChannel}
                        skip_channels={this.props.app.state.skip_channels}
                        request_status={this.state.request_status}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetChannel = child; }}
                    />
                </div>
                <Preview
                    statics={this.state.statics}
                    statics_segments={this.state.statics_segments}
                    statics_channels={this.state.statics_channels}
                    statics_trimester={this.state.statics_trimester}
                    total_widgets={this.state.total_widgets}
                    total_widgets_channels={this.state.total_widgets_channels}
                    hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                    request_status={this.state.request_status}
                    activeWidget={this.activeWidget}
                    filter_by_pace={this.props.app.state.filter_by_pace}
                    app={this.props.app}
                    layout={this}
                    ref={(child) => { this._widgetRoomNights = child; }}
                />
                <Totals
                    statics={this.state.statics}
                    statics_segments={this.state.statics_segments}
                    statics_channels={this.state.statics_channels}
                    statics_trimester={this.state.statics_trimester}
                    total_widgets={this.state.total_widgets}
                    total_widgets_channels={this.state.total_widgets_channels}
                    hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                    request_status={this.state.request_status}
                    activeWidget={this.activeWidget}
                    filter_by_pace={this.props.app.state.filter_by_pace}
                    app={this.props.app}
                    layout={this}
                    ref={(child) => { this._widgetRoomNights = child; }}
                />
                
                <div className={"hidden-widgets "}>
                    <span className={"wdg time " + (this.state.hidden_wdg_time !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"time")}>
                        <div className="opt-w">
                            <span className="">PERIODICITY</span> <i className="fa fa-eye"></i>
                        </div>
                    </span>
                    <span className={"wdg room-nights " + (this.state.hidden_wdg_room_nights !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"room-nights")}>
                        <div className="opt-w">
                            <span className="">PAX</span> <i className="fa fa-eye"></i>
                        </div>
                    </span>
                    <span className={"wdg adr " + (this.state.hidden_wdg_adr !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"adr")}>
                        <div className="opt-w">
                            <span className="">REVENUE PER PAX</span> <i className="fa fa-eye"></i>
                        </div>
                    </span>
                    <span className={"wdg revenue " + (this.state.hidden_wdg_revenue !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revenue")}>
                        <div className="opt-w">
                            <span className="">REVENUE PER PAX</span> <i className="fa fa-eye"></i>
                        </div>
                    </span>
                    <span className={"wdg revpar " + (this.state.hidden_wdg_revpar !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revpar")}>
                        <div className="opt-w">
                            <span className="">REVPAR</span> <i className="fa fa-eye"></i>
                        </div>
                    </span>
                </div>
            </div>
        )
    }
}

export default Reserves



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Reserves.js